import { httpService } from 'src/services/fetch/HttpService';
import { buildUrlWithQueryParams } from 'src/utils/UrlGenerator';
import { STATIC_FOOTER_URL } from 'src/utils/constants/ApiConstants';
import { HTTP_METHODS } from 'src/utils/constants/HttpMethodsConstants';
import { footerDataType } from './Footer';
import { FOOTER_URLS_CONSTANTS } from 'src/utils/constants/stringConstants';
import { footerTextTypeEnums } from 'src/utils/constants/utilConstants';

export const footerApiGenerator = async (
  country_code: string,
  display_language: string,
  isChildFooter?: boolean,
  childFooterDataKey?: string
): Promise<footerDataType[] | null> => {
  let url = STATIC_FOOTER_URL;
  let text_type = footerTextTypeEnums.MEGA_MENU_FOOTER;

  if (isChildFooter && childFooterDataKey) {
    switch (childFooterDataKey) {
      case FOOTER_URLS_CONSTANTS.TV_SHOWS:
      case FOOTER_URLS_CONSTANTS.EPISODES:
        text_type = footerTextTypeEnums.CHILD_FOOTER_SHOWS;
        break;
      case FOOTER_URLS_CONSTANTS.MOVIES:
        text_type = footerTextTypeEnums.CHILD_FOOTER_MOVIES;
        break;
      case FOOTER_URLS_CONSTANTS.SERIES:
      case FOOTER_URLS_CONSTANTS.ORIGINALS:
        text_type = footerTextTypeEnums.CHILD_FOOTER_SERIES;
        break;
      default:
        text_type = footerTextTypeEnums.CHILD_FOOTER;
        break;
    }
  }

  url = buildUrlWithQueryParams(url, {
    ccode: country_code,
    lang: display_language,
    text_type: text_type
  });

  try {
    const data: footerDataType[] = await httpService.fetchApiData({
      url: url,
      type: HTTP_METHODS.GET
    });
    return data;
  } catch (error) {
    console.error('error while calling webfooter api: ', error);
    return null;
  }
};
